<div *ngIf="show" class="splash-container"
     [ngStyle]="{'opacity': opacity}">
  <img class="splash-logo img-fluid" [src]="splash_screen || './assets/img/splash-logo.png'"/>
</div>
